<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="bankacc-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Konta bankowe</h1>
      </div>
    </div>
    <!-- Trigger Button for Dialog -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="bankAccounts"
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('bankAccounts.title') }}</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn
                class="primary"
                @click="
                  (dialog = true),
                    (action = 'Tworzenie'),
                    (currentBankAccountId = null)
                "
                >{{ $t('common.add') }}</v-btn
              >
            </v-toolbar>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoBankAccount(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteBankAccount="{ item }">
            <v-btn class="error" @click="deleteBankAccount(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- Form Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ $t('bankAccounts.addAccountTitle') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
            <v-row>
              <!-- Account Number (IBAN) -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="formData.bankAccountNumber"
                  :label="$t('bankAccounts.accountNumber')"
                  :rules="[computedRules.required, computedRules.bankAccountNumber]"
                  required
                />
              </v-col>

              <!-- Bank Name -->
              <v-col cols="12" md="12">
                <v-combobox
                  v-model="formData.bankName"
                  :items="bankNames"
                  :label="$t('bankAccounts.bankName')"
                  :rules="[computedRules.required]"
                  :hint="$t('bankAccounts.bankNameHint')"
                  persistent-hint
                />
              </v-col>

              <!-- Company IDs (Multi-select) -->
              <!-- <v-col cols="12" md="12">
                <v-select
                  v-model="formData.companyIds"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  label="Firma"
                  multiple
                />
              </v-col> -->
              <!-- Subcompany IDs (Multi-select) -->
              <!-- <v-col cols="12" md="12">
                <v-select
                  v-model="formData.subCompanyIds"
                  :items="subCompanies"
                  item-text="name"
                  item-value="id"
                  label="Oddział"
                  multiple
                />
              </v-col> -->
              <!-- Department IDs (Multi-select) -->
              <!-- <v-col cols="12" md="6">
                <v-select
                  v-model="formData.departmentIds"
                  :items="departments"
                  item-text="name"
                  item-value="id"
                  label="Departament"
                  multiple
                />
              </v-col> -->
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" @click="submitForm" :disabled="!valid">
            {{ $t('common.add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
export default {
  data() {
    return {
      bankAccounts: [],
      headers: [
        {
          text: "Numer Konta",
          align: "start",
          sortable: false,
          value: "bankAccountNumber",
        },
        {
          text: "Bank",
          align: "start",
          sortable: false,
          value: "bankName",
        },
        {
          text: "Firmy",
          align: "start",
          sortable: false,
          value: "companyName",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "deleteBankAccount", sortable: false },
      ],
      loading: false,
      dialog: false,
      valid: false,
      formData: {
        bankAccountNumber: "",
        bankName: null,
        companyIds: [],
        departmentIds: [],
        subCompanyIds: [],
      },
      companies: [],
      departments: [],
      subCompanies: [],
      bankNames: [
        "PKO Bank Polski",
        "Bank Pekao",
        "Santander Bank Polska",
        "ING Bank Śląski",
        "mBank",
        "BNP Paribas",
        "Millennium Bank",
        "Alior Bank",
        "Credit Agricole",
        "Citi Handlowy",
        "BOŚ Bank",
        "Nest Bank",
        "Plus Bank",
        "VeloBank",
        "Toyota Bank",
        "Inny",
      ],
      rules: {},
    };
  },
  computed: {
    computedRules() {
      return {
        required: (value) => !!value || this.$t('common.required'),
        bankAccountNumber: (value) => {
          if (!value) return this.$t('common.required');
          const clean = value.replace(/\s/g, '');
          if (/^[0-9]{26}$/.test(clean)) return true;
          if (/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(clean.toUpperCase())) return true;
          return this.$t('bankAccounts.bankAccountNumberRule');
        },
      };
    },
  },
  async created() {
    await this.initialize();
  },
  watch: {
    "formData.subCompanyIds": function (newVal) {
      if (newVal) {
        this.getDepartmentsSelect();
      } else {
        this.departments = [];
      }
    },
  },
  methods: {
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    async infoBankAccount(id) {
      await this.toggleLoading(true);
      try {
        const bank = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "bank-accounts/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.formData = bank.data.data;
        this.currentBankAccountId = bank.data.data.id;
        this.formData.companyIds = bank.data.data.companies.map(
          (it) => it.companyId
        );
        this.formData.departmentIds = [];
        this.formData.subCompanyIds = bank.data.data.subcompanies.map(
          (it) => it.subcompanyId
        );
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async getSubcompanySelect() {
      await this.toggleLoading(true);
      try {
        const subCompanies = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `sub-company`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.subCompanies = subCompanies.data.data.map((it) => {
          return {
            id: it.id,
            name: it.name,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async initialize() {
      this.loading = true;
      await this.getCompanySelect();
      await this.getSubcompanySelect();
      try {
        const banks = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `bank-accounts`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.bankAccounts = banks.data.data.map((bank) => {
          return {
            bankAccountNumber: bank.bankAccountNumber,
            bankName: bank.bankName,
            id: bank.id,
            companyName: bank.companies.map((it) => it.company.name).toString(),
            subcompanyNames: bank.subcompanies
              .map((it) => it.company.name)
              .toString(),
            departamentNames: bank.departments
              .map((it) => it.company.name)
              .toString(),
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async getDepartmentsSelect() {
      await this.toggleLoading(true);
      try {
        const departaments = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `departments`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          params: {
            subCompanyIds: this.formData.subCompanies,
          },
        });
        this.departments = departaments.data.data.map((it) => {
          return {
            id: it.id,
            name: it.name,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async getCompanySelect() {
      await this.toggleLoading(true);
      try {
        const companies = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `company`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.companies = companies.data.data.map((it) => {
          return {
            id: it.id,
            name: it.name,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async deleteBankAccount(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "bank-accounts/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async submitForm() {
      // Validate the form
      if (this.$refs.form.validate()) {
        try {
          await this.toggleLoading(true);
          await axios({
            method: "post",
            url: process.env.VUE_APP_ROOT_API + "bank-accounts",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            data: {
              ...this.formData,
              id: this.currentBankAccountId || undefined,
            },
          });
          this.closeDialog();
          await this.toggleLoading(false);
          await this.initialize();
        } catch (e) {
          await this.toggleLoading(false);
          console.log(e);
          Swal.fire("Błąd", e.response.data.message.toString(), "error");
        }
      }
    },
    closeDialog() {
      this.dialog = false;
      this.currentBankAccountId = undefined;
      this.formData = {
        bankAccountNumber: "",
        bankName: null,
        companyIds: [],
        departmentIds: [],
        subCompanyIds: [],
      }
      this.$refs.form.resetValidation(); // Reset form validation
    },
  },
};
</script>

<style scoped>
.bankacc-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.bankacc-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.bankacc-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.bankacc-page >>> .v-text-field--outlined fieldset, .bankacc-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.bankacc-page >>> .v-text-field--outlined .v-input__slot, .bankacc-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.bankacc-page >>> .v-label { color: #6E7691 !important; }
.bankacc-page >>> .v-text-field input, .bankacc-page >>> .v-select__selection { color: #fff !important; }
.bankacc-page >>> .v-text-field:not(.v-text-field--outlined) input { color: #fff !important; }
.bankacc-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.bankacc-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.bankacc-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.bankacc-page >>> .v-data-table tbody tr { background: #232838 !important; }
.bankacc-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.bankacc-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.bankacc-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.bankacc-page >>> .v-data-table tbody td .v-btn.warning { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.bankacc-page >>> .v-data-table tbody td .v-btn.error { background: rgba(244,67,54,0.18) !important; color: #FF8A80 !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.bankacc-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }
.bankacc-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.bankacc-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.bankacc-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.bankacc-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.bankacc-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.bankacc-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
